export const formatOrderId = (id: string) => {
  return `O-${id.slice(0, 8).toUpperCase()}`;
};

export const formatTransactionId = (id: string) => {
  return `T-${id.slice(0, 8).toUpperCase()}`;
};
